import React from "react";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

const GrupoEmailsTopo = () => {
  const { t } = useTranslation();

  return (
    <div className="containerTitle">
      <Typography
        variant="h5"
        fontFamily={"Co Headline Regular"}
        gutterBottom
        align="left"
        marginLeft="15px"
      >
        {t("pages.emailsGroups.titlePage")}
      </Typography>
    </div>

  );
};

export default GrupoEmailsTopo;
